import ReactGA from 'react-ga4';
import FaroService from './FaroService';
import * as AuthorizationAPI from '../api/authorizationAPI';
import * as edulaiInstance from '../api/instances/edulaiInstance';
import { getDefaultAPIBaseURL } from '../config/configurations';

let configured = false;

export async function setInstanceConfigurations() {
  if (configured) return edulaiInstance;

  let config = {
    baseUrl: getDefaultAPIBaseURL()
  };
  try {
    if (process.env.NODE_ENV === 'production') {
      const response = await AuthorizationAPI.fetchConfiguration();
      config = response.data;
    }
    edulaiInstance.setBaseUrl(config.baseUrl);
    AuthorizationAPI.setClientSecret(config.clientSecret);
    if (config.googleAnalyticsUUID) {
      ReactGA.initialize(config.googleAnalyticsUUID);
    }
    try {
      FaroService.init({
        ...config,
        grafanaFaroUrl: config.grafanaFaroUrl || process.env.REACT_APP_FARO_URL
      });
      console.log('Faro initialized');
    } catch (error) {
      console.error('Error initializing Faro', error);
    }
    configured = true;
    return edulaiInstance;
  } catch (error) {
    throw error;
  }
}
